import { render, staticRenderFns } from "./branch-form.vue?vue&type=template&id=184f289c&scoped=true&"
import script from "./branch-form.vue?vue&type=script&lang=js&"
export * from "./branch-form.vue?vue&type=script&lang=js&"
import style0 from "./branch-form.vue?vue&type=style&index=0&id=184f289c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f289c",
  null
  
)

export default component.exports